import React, { useEffect, useState } from 'react'
import CopyIcon from '@rsuite/icons/Copy'
import CheckIcon from '@rsuite/icons/Check'

type Props = { value: string; label?: string }

/** Monospace value with a copy button, e.g. an inbox address. */
const CopyChip: React.FC<Props> = ({ value, label }) => {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) return undefined
    const t = setTimeout(() => setCopied(false), 1600)
    return () => clearTimeout(t)
  }, [copied])

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
    } catch {
      // Clipboard can be blocked (insecure origin); the value stays selectable.
    }
  }

  return (
    <span className="dx-copy">
      <code className="dx-copy__value">{value}</code>
      <button
        type="button"
        className="dx-icon-btn dx-icon-btn--sm"
        onClick={copy}
        aria-label={copied ? 'Copied' : `Copy ${label ?? value}`}
        title={copied ? 'Copied' : 'Copy'}
      >
        {copied ? <CheckIcon /> : <CopyIcon />}
      </button>
    </span>
  )
}

export default CopyChip
